import { render, staticRenderFns } from "./fateClass.vue?vue&type=template&id=21fca9e9&scoped=true&"
import script from "./fateClass.vue?vue&type=script&lang=ts&"
export * from "./fateClass.vue?vue&type=script&lang=ts&"
import style0 from "./fateClass.vue?vue&type=style&index=0&id=21fca9e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fca9e9",
  null
  
)

export default component.exports